(function () {
  window.MAKIA_TRANSLATIONS = window.MAKIA_TRANSLATIONS || {};

  // Finnish translations. Inner <span rivo-x-text="..."> placeholders MUST be
  // kept intact — Rivo fills them with live customer data (name, points, tier).

  window.MAKIA_TRANSLATIONS.fi = {

    // Rivo loyalty-page translation store (rivo-x-html="$store.rivo_lp_translation.X")
    rivo_lp_translation: {
      loyalty_page_ways_to_earn_title: 'Tapoja ansaita pisteitä',
      loyalty_page_ways_to_earn_subtitle: 'Ansaitse pisteitä jokaisesta ostoksesta sekä suorittamalla näitä aktiviteetteja.',
      loyalty_page_ways_to_redeem_title: 'Käytä pisteitä',
      loyalty_page_ways_to_redeem_subtitle: 'Lunasta pisteitä näihin palkintoihin:',
      loyalty_page_vip_tiers_logged_out_title: 'Palkintotasot',
      loyalty_page_vip_tiers_logged_out_subtitle: 'Liity palkinto-ohjelmaamme ja avaa eksklusiivisia etuja.',
      loyalty_page_vip_tiers_logged_in_title: 'Palkintotasot',
      loyalty_page_vip_tiers_logged_in_subtitle: 'Olet <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.tier?.name">Bronze</span>-tasolla',
      loyalty_page_vip_tier_1_threshold_text: '0 pistettä',
      loyalty_page_vip_tier_2_threshold_text: '1500 pistettä',
      loyalty_page_vip_tier_3_threshold_text: '5000 pistettä'
    },

    // Rivo account-dashboard translation store (rivo-x-html="$store.translations.X")
    translations: {
      account_dashboard_member_card_header_title: 'Tervetuloa <span rivo-x-data="" rivo-x-text="$store.customer?.first_name">Christa</span>',
      account_dashboard_member_card_body_title: 'Sinulla on <strong><span rivo-x-data="" rivo-x-text="$store.customer.pretty_points_tally">200</span></strong> pistettä',
      account_dashboard_member_card_body_subtitle: 'Olet <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.tier?.name">Bronze</span>-tasolla',
      account_dashboard_member_card_cta_text: 'Katso palkinnot',
      account_dashboard_rewards_progress_block_subtitle: 'Ansaitse vielä <span rivo-x-data="" rivo-x-text="$store.customer.pretty_points_amount_to_next_reward">300</span> pistettä avataksesi palkinnon <span rivo-x-data="" rivo-x-text="$store.customer.next_reward?.name">€5 off coupon</span>',
      account_dashboard_rewards_progress_block_completed_subtitle: 'Jatka pisteiden keräämistä avataksesi lisää palkintoja',
      account_dashboard_vip_tiers_progress_subtitle: 'Ansaitse <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.next_tier?.formatted_to_spend_or_earn">1,300</span> pistettä saavuttaaksesi <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.next_tier?.name">Silver</span>-tason.',
      account_dashboard_vip_tiers_progress_completed_subtitle: 'Onnittelut! Olet saavuttanut korkeimman tason.'
    },

    // Earning rules ($store.loy_config.ways_to_earn) keyed by id.
    earning_rules: {
      '315652': { title: 'Tee tilaus',              desc: 'Ansaitse pisteitä jokaisesta käytetystä eurosta' },
      '315653': { title: 'Juhli syntymäpäivääsi',   desc: '500 pistettä' },
      '315674': { title: 'Kirjoita tuotearvostelu', desc: '250 pistettä' },
      '315675': { title: 'Seuraa Instagramissa',    desc: '200 pistettä' },
      '577595': { title: 'Suosittele kaverille',    desc: 'Pisteitä suosittelukampanjasta' }
    },

    // Rewards ($store.loy_config.rewards) keyed by id.
    rewards: {
      '373706': { name: '5 € alennuskuponki',  description: '500 pistettä' },
      '373707': { name: '10 € alennuskuponki', description: '1 000 pistettä' },
      '373708': { name: '20 € alennuskuponki', description: '2 000 pistettä' },
      '433394': { name: '50 € alennuskuponki', description: '5 000 pistettä' }
    },

    // VIP tier table — perk row labels (keyed by English original).
    perks: {
      'Unlock by spending':              'Avautuu kuluttamalla',
      'Additional offers and discounts': 'Lisätarjouksia ja alennuksia',
      'Birthday rewards':                'Syntymäpäiväpalkinnot',
      'Free shipping':                   'Ilmainen toimitus',
      'Early access to launches':        'Aikaisempi pääsy lanseerauksiin',
      'Double points events':            'Tuplapistetapahtumat',
      'Exclusive event invitations':     'Eksklusiiviset tapahtumakutsut'
    },

    // VIP tier table — cell values (keyed by English original).
    perk_values: {
      'Yes':                          'Kyllä',
      '–':                            '–',
      'Orders over 79€':              'Yli 79 € tilaukset',
      'Orders over 59€':              'Yli 59 € tilaukset',
      'Free shipping on everything':  'Ilmainen toimitus kaikkiin tilauksiin',
      '500 points':                   '500 pistettä',
      '1000 points':                  '1000 pistettä'
    },

    // Strings hardcoded in the Liquid-rendered HTML (no Rivo translation key).
    'static': {
      'Your Activity':                          'Aktiviteettisi',
      'Activity':                               'Aktiviteetti',
      'Points':                                 'Pisteet',
      'Date':                                   'Päivämäärä',
      'No activity yet':                        'Ei aktiviteettia vielä',
      'Earn more rewards':                      'Ansaitse lisää palkintoja',
      'Use your rewards':                       'Käytä palkintosi',
      'Use your previously redeemed rewards:':  'Käytä aiemmin lunastamasi palkinnot:',
      'VIP Tier Status':                        'VIP-tason tila'
    }
  };
})();
